import config from "config/config";
import HandleApiResponse from "utils/handleApiResponse";

const exitManagement = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getAllClearanceResignationsAPI(values) {
      try {
        const obj = {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        };
        const query = JSON.stringify(values);
        const res = await fetch(
           `${config.host}/panel/ems/clearance/allResignations?query=${query}`,
          obj
        );
        return handleResponse(res);
      } catch (err) {
        handleError(err);
      }
    }

     async function getEmployeeClearanceItemsAPI(values) {
      try {
        const obj = {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        };
        // const query = JSON.stringify(values);
        const res = await fetch(
          `${config.host}/panel/ems/clearance/items?exitId=${values}`,
          obj
        );
        return handleResponse(res);
      } catch (err) {
        handleError(err);
      }
    }

    async function updateResignationAPI(value) {
              try {
                const obj = {
                  method: "Post",
                  credentials: "include",
                  headers: {
                    "Content-Type": "application/json",
                  },
                 body : JSON.stringify(value)
                };
                
                let res = await fetch(
                 `${config.host}/panel/ems/clearance/updateResignation`,
                     obj
                    );
                return handleResponse(res);
              } catch (err) {
                handleError(err);
              }
            }

     async function getHRAllResignationsAPI(values) {
      try {
        const obj = {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        };
        const query = JSON.stringify(values);
        const res = await fetch(
           `${config.host}/panel/ems/hr/allResignations?query=${query}`,
          obj
        );
        return handleResponse(res);
      } catch (err) {
        handleError(err);
      }
    }

     async function getOneResignationsAPI(values) {
      try {
        const obj = {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        };
        
        const res = await fetch(
          `${config.host}/panel/ems/oneResignation?exitId=${values}`,
          obj
        );
        return handleResponse(res);
      } catch (err) {
        handleError(err);
      }
    }

      async function getResignationApprovalDetailsAPI(values) {
      try {
        const obj = {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        };
        
        const res = await fetch(
          `${config.host}/panel/ems/approvalDetails?exitId=${values}`,
          obj
        );
        return handleResponse(res);
      } catch (err) {
        handleError(err);
      }
    }

    async function hrUpdateResignationAPI(value) {
              try {
                const obj = {
                  method: "Post",
                  credentials: "include",
                  headers: {
                    "Content-Type": "application/json",
                  },
                 body : JSON.stringify(value)
                };
                
                let res = await fetch(
                `${config.host}/panel/ems/hr/updateResignation`,
                     obj
                    );
                return handleResponse(res);
              } catch (err) {
                handleError(err);
              }
            }

      async function getHRCompletedResignationsAPI(values) {
      try {
        const obj = {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        };
        const query = JSON.stringify(values);
        const res = await fetch(
         `${config.host}/panel/ems/hr/completedResignations?query=${query}`,
          obj
        );
        return handleResponse(res);
      } catch (err) {
        handleError(err);
      }
    }

   async function hrFinalApproveResignationAPI(value) {
              try {
                const obj = {
                  method: "Post",
                  credentials: "include",
                  headers: {
                    "Content-Type": "application/json",
                  },
                 body : JSON.stringify(value)
                };
                
                let res = await fetch(
               `${config.host}/panel/ems/hr/finalApprove`,
                     obj
                    );
                return handleResponse(res);
              } catch (err) {
                handleError(err);
              }
            }

            async function hrCloseFinanceClearanceAPI(value) {
              try {
                const obj = {
                  method: "Post",
                  credentials: "include",
                  headers: {
                    "Content-Type": "application/json",
                  },
                 body : JSON.stringify(value)
                };
                
                let res = await fetch(
               `${config.host}/panel/ems/hr/closeFinanceClearance`,
                     obj
                    );
                return handleResponse(res);
              } catch (err) {
                handleError(err);
              }
            }

      async function getManagerAllResignationsAPI(values) {
      try {
        const obj = {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        };
        const query = JSON.stringify(values);
        const res = await fetch(
          `${config.host}/panel/ems/manager/allResignations?query=${query}`,
          obj
        );
        return handleResponse(res);
      } catch (err) {
        handleError(err);
      }
    }

     async function managerUpdateResignationAPI(value) {
              try {
                const obj = {
                  method: "Post",
                  credentials: "include",
                  headers: {
                    "Content-Type": "application/json",
                  },
                 body : JSON.stringify(value)
                };
                
                let res = await fetch(
                `${config.host}/panel/ems/manager/updateResignation`,
                     obj
                    );
                return handleResponse(res);
              } catch (err) {
                handleError(err);
              }
            }


  return {
    getAllClearanceResignationsAPI,
    getEmployeeClearanceItemsAPI,
    updateResignationAPI,
    getHRAllResignationsAPI,
    getOneResignationsAPI,
    getResignationApprovalDetailsAPI,
    hrUpdateResignationAPI,
    getHRCompletedResignationsAPI,
    hrFinalApproveResignationAPI,
    hrCloseFinanceClearanceAPI,
    getManagerAllResignationsAPI,
    managerUpdateResignationAPI,
  }

}

export default exitManagement;